export enum InputBorderEnum {
    FULL_BORDER = 'fullBorder',
    BOTTOM_BORDER = 'bottomBorder',
}
